"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("arrow", _flowRuntime["default"].union(_flowRuntime["default"].string("left"), _flowRuntime["default"].string("right")), true), _flowRuntime["default"].property("disabled", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("invalid", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("label", _flowRuntime["default"].string()), _flowRuntime["default"].property("level", _flowRuntime["default"].union(_flowRuntime["default"].string("primary"), _flowRuntime["default"].string("secondary"), _flowRuntime["default"].string("tertiary"), _flowRuntime["default"].string("link")), true), _flowRuntime["default"].property("loading", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("type", _flowRuntime["default"].union(_flowRuntime["default"].string("button"), _flowRuntime["default"].string("submit"))), _flowRuntime["default"].property("onClick", _flowRuntime["default"]["function"](_flowRuntime["default"].param("e", _flowRuntime["default"].ref("SyntheticEvent", _flowRuntime["default"].ref("HTMLButtonElement"))), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]())), true)));

var Button = function Button(_arg) {
  var arrow = _arg.arrow,
      disabled = _arg.disabled,
      invalid = _arg.invalid,
      label = _arg.label,
      level = _arg.level,
      loading = _arg.loading,
      onClick = _arg.onClick,
      type = _arg.type;
  var buttonClass = (0, _classnames["default"])('btn btn--medium btn--inline', {
    'btn--primary': level === 'primary',
    'btn--secondary': level === 'secondary',
    'btn--tertiary': level === 'tertiary',
    'btn--link': level === 'link',
    'right-arrow': arrow === 'right',
    'left-arrow': arrow === 'left',
    'btn--invalid': invalid
  });
  return /*#__PURE__*/_react["default"].createElement("button", {
    // eslint-disable-next-line react/button-has-type
    type: type,
    disabled: disabled,
    className: buttonClass,
    onClick: onClick
  }, label, loading && /*#__PURE__*/_react["default"].createElement("div", {
    className: "loader loader--btn"
  }, "\xA0"));
};

Button.defaultProps = {
  arrow: undefined,
  disabled: false,
  invalid: false,
  level: 'primary',
  loading: false,
  onClick: undefined
};
var _default = Button;
exports["default"] = _default;